export default [
  { title: "What's new in eSignature API v2.1", icon: "", link: "/docs/versioning/new" },
  { title: "Upgrading from v2.0 to v2.1", icon: "", link: "/docs/versioning/upgrading" },
  { title: "Release notes", icon: "", link: "/docs/versioning/release-notes" },
];
